import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { AlertTriangle } from 'lucide-react';
import { cn } from '../utils/cn';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const isProd = window.location.hostname === 'nrm.neosavvy.com';

  const handleToggle = () => setSidebarOpen(!sidebarOpen);
  const handleClose = () => setSidebarOpen(false);

  return (
    <div className="flex min-h-screen">
      {!isProd && (
        <div className="fixed top-0 left-0 right-0 bg-yellow-500/10 border-b border-yellow-500/20 py-2 px-4 text-yellow-500 z-50 flex items-center justify-center gap-2 h-9">
          <AlertTriangle className="w-4 h-4" />
          <span className="text-sm font-medium">You are viewing a non-production environment</span>
        </div>
      )}
      <div className={cn(
        "flex min-h-screen w-full",
        !isProd && "pt-9" // Add top padding when banner is present
      )}>
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={handleClose}
          onToggle={handleToggle}
          hasWarningBanner={!isProd}
        />
        <div className={cn(
          "flex-1 flex flex-col transition-all duration-200 max-w-full",
          sidebarOpen ? "lg:ml-64" : "lg:ml-20"
        )}>
          <TopBar onMenuClick={handleToggle} />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-dark-900 px-4 md:px-6 py-6">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}